import Joi from "joi";
import { Input } from "../form/validatedInput";
import { MetricEditingState } from "./editMetric";

type PropType = {
    comparator: string,
    metric: MetricEditingState,
    onUpdate: (value: any) => void,
    disabled?: boolean
}
export const RAGInput: React.FC<PropType> = ({comparator, metric, onUpdate, disabled = false}) => {
    const formatToTwoDecimalPlaces = (value: string): number => {
        const num = parseFloat(value);
        if (isNaN(num)) return 0;
        return Number(num.toFixed(2));
    };
    const renderInputs = () => {
        switch(comparator) {
            case 'RAG':
                return (
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <Input 
                            type="number" 
                            step={0.01}
                            value={metric.value1} 
                            onChange={(v) => onUpdate({ ...metric, value1: formatToTwoDecimalPlaces(v) })} 
                            schema={Joi.number()} 
                            label="Red-Amber" 
                            disabled={disabled}
                        />
                        <Input 
                            type="number" 
                            step={0.01}
                            value={metric.value2 || 0} 
                            onChange={(v) => onUpdate({ ...metric, value2: formatToTwoDecimalPlaces(v) })} 
                            schema={Joi.number()} 
                            label="Amber-Green" 
                            disabled={disabled}
                        />
                    </div>
                );
            case 'RG':
                return (
                    <div>
                        <Input 
                            type="number" 
                            step={0.01}
                            value={metric.value1} 
                            onChange={(v) => onUpdate({ ...metric, value1: formatToTwoDecimalPlaces(v) })} 
                            schema={Joi.number()} 
                            label="Red-Green" 
                            disabled={disabled}
                        />
                    </div>
                );
            case 'GR':
                return (
                    <div>
                        <Input 
                            type="number" 
                            step={0.01}
                            value={metric.value1} 
                            onChange={(v) => onUpdate({ ...metric, value1: formatToTwoDecimalPlaces(v) })} 
                            schema={Joi.number()} 
                            label="Green-Red" 
                            disabled={disabled}
                        />
                    </div>
                );
            case 'GAR':
                return (
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <Input 
                            type="number" 
                            step={0.01}
                            value={metric.value1} 
                            onChange={(v) => onUpdate({ ...metric, value1: formatToTwoDecimalPlaces(v) })} 
                            schema={Joi.number()} 
                            label="Green-Amber" 
                            disabled={disabled}
                        />
                        <Input 
                            type="number" 
                            step={0.01}
                            value={metric.value2 || 0} 
                            onChange={(v) => { console.log(v); onUpdate({ ...metric, value2: formatToTwoDecimalPlaces(v) })}} 
                            schema={Joi.number()} 
                            label="Amber-Red" 
                            disabled={disabled}
                        />
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <h3>Thresholds</h3>
            {renderInputs()}
        </div>
    );
}